module.exports = __webpack_public_path__ + "static/img/born-to-play.88f2173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/born-to-play.png
// module id = JxPS
// module chunks = 12